<template>
  <div class="card-article">
    <div class="card-meta">
      <ui-avatar
        :url="article.userInfo.avatar"
        :username="article.userInfo.username ? article.userInfo.username : $t('anonymous')"
      ></ui-avatar>
      <!-- <span v-if="article.geo" class="muted">|</span><span v-if="article.geo">{{article.geo.address}}<i :class="'editor-icon-' + article.geo.weather.weatherCode"></i></span> -->
    </div>
    <div class="card-cover-list" v-if="article.coverList">
      <ui-image
        @click.native="$router.push('/article/' + article.id)"
        :src="cover"
        v-for="cover of article.coverList"
        :key="cover"
      ></ui-image>
    </div>
    <div
      class="card-content"
      @click.native="$router.push('/article/' + article.id)"
    >
      <p class="mb20" v-if="article.shortContent">{{ article.shortContent }}</p>
      <!-- <p class="mb20" v-if="!article.shortContent">{{$t('noContent')}}</p> -->
      <p>
        <router-link :to="'/article/' + article.id"
          >{{ $t("readMore") }}
          <ui-icon name="icon-right"></ui-icon>
        </router-link>
      </p>
    </div>
    <div class="card-date">
      <p class="day">{{ $d(new Date(article.created), "day") }}</p>
      <p class="month">{{ $d(new Date(article.created), "monthLong") }}</p>
      <p class="year">{{ $d(new Date(article.created), "year") }}</p>
    </div>
  </div>
</template>
<script>
import { convertUrl } from "../../utils/utils.js";

export default {
  name: "CardArticle",
  computed: {
    cardClass() {
      return {
        "card-article-with-cover": this.article.coverList.length
      };
    }
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    shadow: {
      type: Boolean,
      default: false
    },
    shadowHover: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loaded: false,
      musicImg: import("../../assets/music.png")
    };
  },
  methods: {
    // renderUrl(cover) {
    //   if (cover.mimetype.indexOf("audio") == -1) {
    //     return convertUrl(cover.url, "sm");
    //   } else {
    //     return cover.cover ? "data:image/png;base64," + cover.cover : musicImg;
    //   }
    // }
  }
};
</script>
